import { trackError } from 'helpers/track_error';
import { useEffect, useState } from 'react';
import getCookieValue from 'helpers/get_cookie';
import { getFeatureVariable } from 'helpers/gusto_ffe';

const useReferralData = () => {
  const [referrer, setReferrer] = useState<string>();
  const [refereeAmount, setRefereeAmount] = useState<string>();
  const [doubleRefereeAmount, setDoubleRefereeAmount] = useState<string>();
  const [isEOY22ReferralCampaignActive, setIsEOY22ReferralCampaignActive] = useState<boolean>();
  const referralSource = getCookieValue('referral_token');

  useEffect(() => {
    async function getReferralData() {
      try {
        const multiplicativeReferralsEnabled = await getFeatureVariable(
          'multiplicative_referrals',
          'UserRole'
        );
        const response = await fetch('/referral_data');
        if (response.ok) {
          const data = await response.json();
          setReferrer(data?.referrer);
          setRefereeAmount(data?.referee_amount);
          setDoubleRefereeAmount(data?.double_referee_amount);
        } else {
          throw new Error('Error getting referrals data');
        }
        setIsEOY22ReferralCampaignActive(!!multiplicativeReferralsEnabled);
      } catch {
        trackError({
          error: new Error('Error getting referrals data'),
        });
      }
    }

    if (referralSource && !referrer) {
      getReferralData();
    }
  }, [referralSource, referrer]);

  return {
    referralSource,
    referrer,
    refereeAmount,
    doubleRefereeAmount,
    isEOY22ReferralCampaignActive,
  };
};

export default useReferralData;
